/**
 * Account login event - tracks when a user successfully logs into their account.
 *
 * @example Usage (preferred)
 * const { trackEvent } = useCohesion()
 *
 * trackEvent(EventCreators.accountLogin({
 *   userContext: {
 *     anonymousId: 'officia aliquip culpa quis Ut',
 *     correlationId: 'do velit',
 *     instanceId: 'aute exercitation',
 *     sessionId: 'qui'
 *   },
 *   customerId: 'culpa aliquip qui',
 *   loginSource: 'ullamco in',
 *   loginSourceId: 'consectetur exercitation',
 *   hashedEmail: 'ut nulla ad Excepteur Ut'
 * }))
 */

import { z } from 'zod';

import { defineEvent } from '../event-factory';

export default defineEvent({
  eventName: 'core.AccountLogin.v1',

  // What data this event needs (see schema link for full details)
  // https://app.make.rvohealth.com/schemas/sch_1humdWcQ8Qo6cDw8uG886WMhhqQ
  cohesionSchema: {
    userContext: z.object({
      anonymousId: z.string(),
      correlationId: z.string().optional(),
      instanceId: z.string().optional(),
      sessionId: z.string().optional(),
    }),
    customerId: z.string().optional(),
    loginSource: z.string().optional(),
    loginSourceId: z.string().optional(),
    hashedEmail: z.string(),
  },

  tealiumMethodType: 'link',
});
